export {
  bindFileBrowserActivitySharedBuffer,
  getFileBrowserActivitySharedBuffer,
} from './activity-shared.js';

export { BROWSE_INDEX_COOLDOWN_MS, type FileBrowserActivitySnapshot } from './activity-types.js';

export {
  applyFileBrowserActivityFromMain,
  beginFileBrowserRead,
  beginFileBrowserRequest,
  endFileBrowserRead,
  endFileBrowserRequest,
  fileBrowserReadInFlight,
  fileBrowserRequestInFlight,
  getFileBrowserActivitySnapshot,
  getFileBrowserInFlightReadCount,
  publishFileBrowserActivityToWorker,
  registerFileBrowserActivityListener,
  registerFileBrowserActivityPublisher,
  registerFileBrowserReadStartListener,
  registerFileBrowserRequestStartListener,
} from './activity-tracker.js';

export {
  assertBackgroundIndexingAllowed,
  isBridgeBrowseInteractiveActive,
  yieldForBridgeInteractivePriority,
  yieldUntilBackgroundIndexingAllowed,
  yieldUntilFileBrowserBrowseIdle,
  yieldUntilFileBrowserIdle,
  yieldUntilFileBrowserReadsIdle,
} from './idle-yield.js';
